import { useEffect, useCallback, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useQuery } from 'react-query'

import { getMerchantBankAccountAPI } from 'api/merchant'
import { useMerchantBankAccountsStore } from 'store/merchantBankAccounts'
import { MerchantBankAccountsFetchParamsTypes } from 'types/merchantBankAccounts'

import { DATASTATUS } from 'constants/status'

export const useMerchantBankAccounts = () => {
  const { traderId } = useParams()
  const merchantTraderId = parseInt(String(traderId) || '0')
  const defaultParams = { traderId: merchantTraderId }

  const bankAccountsModStatus = useMerchantBankAccountsStore(
    (state) => state.merchantBankAccountsModStatus
  )
  const bankAccountsModStatusSet = useMerchantBankAccountsStore(
    (state) => state.merchantBankAccountsModStatusSet
  )
  const bankAccountsModErrors = useMerchantBankAccountsStore(
    (state) => state.merchantBankAccountsModErrors
  )
  const bankAccountsModErrorsSet = useMerchantBankAccountsStore(
    (state) => state.merchantBankAccountsModErrorsSet
  )
  const merchantBankAccounts = useMerchantBankAccountsStore((state) => state.merchantBankAccounts)
  const bankAccountsSet = useMerchantBankAccountsStore((state) => state.merchantBankAccountsSet)
  const [bankAccountsFilterParams, bankAccountsFilterParamsSet] =
    useState<MerchantBankAccountsFetchParamsTypes>(defaultParams)
  const [isbankAccountsFiltered, isbankAccountsFilteredSet] =
    useState<boolean>(false)

  const {
    data: dataBankAccounts,
    isLoading: isLoadingBankAccounts,
    isError: isErrorBankAccounts,
  } = useQuery({
    refetchOnWindowFocus: false,
    queryKey: ['useMerchantBankAccounts', bankAccountsFilterParams],
    queryFn: async () => {
      try {
        bankAccountsModStatusSet('loading')
        const response = await getMerchantBankAccountAPI(merchantTraderId)
        if (response.outcomeCode === DATASTATUS.outcomeCode) throw response
        bankAccountsModStatusSet('success')
        return response.data
      } catch (e) {
        bankAccountsModStatusSet('fail')
        bankAccountsModErrorsSet(JSON.stringify(e))
      }
    },
  })

  const handleFilter = useCallback(
    async (fetchParams: MerchantBankAccountsFetchParamsTypes) => {
      bankAccountsFilterParamsSet(fetchParams)
      isbankAccountsFilteredSet(true)
    },
    [bankAccountsFilterParamsSet, isbankAccountsFilteredSet]
  )

  const handleUnfilter = useCallback(() => {
    const test = { traderId: merchantTraderId }
    bankAccountsFilterParamsSet(test)
    isbankAccountsFilteredSet(false)
  }, [bankAccountsFilterParamsSet, isbankAccountsFilteredSet])

  useEffect(() => {
    if (dataBankAccounts) bankAccountsSet(dataBankAccounts)
  }, [dataBankAccounts, bankAccountsSet])

  return {
    merchantHandleBankAccountsFilter: handleFilter,
    merchantHandleBankAccountsUnfilter: handleUnfilter,
    bankAccountsFilterParams: bankAccountsFilterParams,
    merchantBankAccounts: merchantBankAccounts,
    merchantBankAccountsModStatus: bankAccountsModStatus,
  }
}
